import Alert from 'components/Alert'
import { Modal } from 'components/desktop/common/Modal'
import { Loading } from 'components/shard'
import useSecure3dsHook from 'hooks/3dsHook'
import _ from 'lodash'
import React from 'react'
import styled from 'styled-components'

const Result3dsPage = ({ isMobile = false }) => {
  const {
    isProcessing,
    errorMsg,
    setErrorMsg,
    isUpdateCreditCard,
    modalDisplay,
    closeModal,
    redirectDetailContract,
    redirectPayEdit,
  } = useSecure3dsHook()

  const debounceOkClick = _.debounce(() => {
    redirectDetailContract()
  }, 300)

  return (
    <Wrapper>
      <MainWrapper isMobile={isMobile}>
        <Page>
          <TopSection>
            {errorMsg.length > 0 && (
              <Alert
                type="error"
                message="エラー"
                description={errorMsg}
                onClose={() => {
                  setErrorMsg('')
                  redirectPayEdit()
                }}
              />
            )}
            <Modal
              title={isUpdateCreditCard ? '更新完了' : '登録完了'}
              text={
                isUpdateCreditCard ? 'クレジットカードの更新が完了しました' : 'クレジットカードの登録が完了しました'
              }
              caution="ご利用ご契約状況詳細画面に戻ります"
              display={modalDisplay}
              overlayOnClick={closeModal}
              buttonOnClick={debounceOkClick}
            />
            <MenuArea>
              <Loading display={isProcessing} />
            </MenuArea>
          </TopSection>
        </Page>
      </MainWrapper>
    </Wrapper>
  )
}

export default Result3dsPage

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  font-family: '游ゴシック体', YuGothic, '游ゴシック Medium', 'Yu Gothic Medium', '游ゴシック', 'Yu Gothic',
    -apple-system, BlinkMacSystemFont, 'Hiragino Kaku Gothic ProN', 'Noto Sans JP', 'メイリオ', Meiryo, Sans-Serif;
`
const MainWrapper = styled.div`
  padding: ${(props) => (props.isMobile ? '0 5.33333vw' : '85px 40px 0 40px')};
`

const Page = styled.div`
  grid-column: 2;
`

const TopSection = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(min-content, 1440px) 1fr;
  color: #acacac;
`

const MenuArea = styled.div`
  grid-column: 2;
  min-height: 100px;

  button {
    @media screen and (max-width: 768px) {
      min-width: 5.73333vw;
      min-height: 2.73333vw;
      font-size: 3.73333vw;
    }
  }
`
